import angular from 'angular';
import uiRouter from 'angular-ui-router';
import benefitRequestListComponent from './benefitRequestList.component';

let benefitRequestListModule = angular.module('benefitRequestList', [
  uiRouter
])

  .component('benefitRequestList', benefitRequestListComponent)

  .name;

export default benefitRequestListModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestList.js